import React, { useEffect, useState } from 'react';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from '@mui/material';
import Modal from './Modal';
import { exportTestCases } from '../../modules/entity-details';
import { getCurrentProject } from '../../modules/project';
import { formatDate } from '../../lib/utils';

const FileExportComponent = ({
  show,
  handleClose,
  projectId,
  selectedTestcases,
}) => {
  const [currentProject, setCurrentProject] = useState(null);
  const fetchCurrentProject = async () => {
    if (projectId) {
      const response = await getCurrentProject(projectId);
      setCurrentProject(response);
    }
  };
  useEffect(() => {
    if (projectId) {
      fetchCurrentProject();
    }
  }, [projectId]);

  const handleExport = async () => {
    const testCaseIds = selectedTestcases.map((testcase) => testcase.id);
    try {
      const payload = {
        testcases: testCaseIds.length > 0 ? testCaseIds : undefined,
      };

      const response = await exportTestCases(payload, projectId);
      const url = window.URL.createObjectURL(response);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${currentProject?.name || 'Project'}-TestCases-${formatDate(new Date())}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      handleClose();
    } catch (error) {
      console.error('Export error:', error);
    }
  };

  return (
    <Modal
      modalTitle="Export Test Cases to CSV"
      open={show}
      handleClose={handleClose}
      width="md"
      action={() => (
        <>
          <Button title="Close"variant="outlined" color="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="contained" title="Export" onClick={handleExport}>
            Export
          </Button>
        </>
      )}>
      {selectedTestcases.length > 0 ? (
        <>
          <Typography variant="body1" paragraph>
            You are about to export the following test cases:
          </Typography>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>Key</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Summary</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedTestcases.map((testcase) => (
                  <TableRow key={testcase.id}>
                    <TableCell>{testcase.key}</TableCell>
                    <TableCell>{testcase.summary}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : (
        <Typography variant="body1" paragraph>
          No specific test cases selected. Therefore, all test cases associated
          with this project will be exported.
        </Typography>
      )}
    </Modal>
  );
};

export default FileExportComponent;
